import Button from "common/components/Button/Button"
import { withFormik } from "formik"
import { InputTextarea } from "primereact/inputtextarea"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { setShowObservaciones } from "../redux/slices/newDocumentoSettingsSlice"
import { setObservaciones } from "../redux/slices/newDocumentoSlice"

const Observaciones = ({
  handleSubmit,
  values,
  handleChange,
  onHide,
  isValid,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='observaciones'>
            {t("crear.facturaRec.modal.observationLabel")}
          </label>
          <InputTextarea
            autoFocus
            rows={5}
            cols={10}
            autoResize
            id='observaciones'
            name='observaciones'
            aria-describedby='username-help'
            value={values.observaciones}
            onChange={handleChange}
            autoComplete='off'
          />
        </div>
      </div>
      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>
          <Button
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
          >
            {t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  observaciones: Yup.string().min(1).required(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'observaciones' does not exist on type '{...
  mapPropsToValues: ({ observaciones }) => ({
    observaciones,
  }),
  handleSubmit: ({ observaciones }, { props }) => {
    // @ts-expect-error TS(2339): Property 'setObservaciones' does not exist on type...
    props.setObservaciones(observaciones)
    // @ts-expect-error TS(2339): Property 'setShowObservaciones' does not exist on ...
    props.setShowObservaciones(true)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(Observaciones)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setObservaciones: (observaciones: $TSMigrationFixMe) =>
    dispatch(setObservaciones(observaciones)),
  setShowObservaciones: (show: $TSMigrationFixMe) =>
    dispatch(setShowObservaciones(show)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  observaciones: newDocumentoSelector(state).observaciones,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
